const AppConfig = {
  site_url:
    process.env.NODE_ENV === 'production'
      ? 'https://mcel.ca/'
      : 'https://localhost:3000',
  site_name: 'Morgan Construction',
  seo_title: 'Morgan Construction',
  seo_description: '',
};

export default AppConfig;
